import { render, staticRenderFns } from "./ys_report.vue?vue&type=template&id=5a2dd060&scoped=true"
import script from "./ys_report.vue?vue&type=script&lang=js"
export * from "./ys_report.vue?vue&type=script&lang=js"
import style0 from "./ys_report.vue?vue&type=style&index=0&id=5a2dd060&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2dd060",
  null
  
)

export default component.exports